import { render } from "./calendario.vue?vue&type=template&id=27db109e&scoped=true"
import script from "./calendario.vue?vue&type=script&lang=js"
export * from "./calendario.vue?vue&type=script&lang=js"

import "./calendario.vue?vue&type=style&index=0&id=27db109e&lang=scss&scoped=true"
import "./calendario.vue?vue&type=style&index=1&id=27db109e&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27db109e"]])

export default __exports__